module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top_bar",
    attrs: {
      "id": "topp"
    }
  }, [_c('u-animate-container', {
    staticClass: "wow-wrap"
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('u-animate', {
    staticClass: "logo",
    attrs: {
      "name": "fadeInDown",
      "delay": "0s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.props.acf.logo) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.logo,
      "alt": "logo"
    }
  }) : _vm._e()])], 1), _c('u-animate', {
    staticClass: "addinfo",
    attrs: {
      "name": "fadeInRightBig",
      "delay": "0s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.props.acf.smile_logo) ? _c('img', {
    staticClass: "decoration",
    attrs: {
      "src": _vm.props.acf.smile_logo,
      "alt": "",
      "width": "55"
    }
  }) : _vm._e(), (_vm.props.acf.address_url) ? _c('router-link', {
    staticClass: "addy",
    attrs: {
      "to": _vm.props.acf.address_url
    }
  }, [(_vm.props.acf.address) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  }) : _vm._e()]) : _vm._e(), (_vm.props.acf.phone) ? _c('a', {
    staticClass: "phone",
    attrs: {
      "href": "tel:" + _vm.props.acf.phone,
      "itemprop": "telephone"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  })]) : _vm._e()], 1), (_vm.props.acf.social_list) ? _c('div', {
    staticClass: "social-media"
  }, _vm._l((_vm.props.acf.social_list), function(SocialList, i) {
    return _c('div', {
      staticClass: "social_list"
    }, [_c('u-animate', {
      staticClass: "social_item",
      attrs: {
        "name": "fadeInRight",
        "delay": 1 + i / 4 + "s",
        "duration": "1.2s",
        "iteration": 1,
        "offset": 0,
        "animateclass": "animated",
        "begin": false
      }
    }, [_c('a', {
      attrs: {
        "href": SocialList.url,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon",
      class: SocialList.icon_class
    })])])], 1)
  })) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "menu_bar"
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('nav', {
    staticClass: "navigation navigation_header"
  }, [_vm._m(0), _c('ul', {
    staticClass: "main_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home         ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-dr-deborah-new"
    }
  }, [_c('span', [_vm._v("About Us ")])]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-dr-deborah-new"
    }
  }, [_c('span', [_vm._v("Meet Dr. Deborah New")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-the-team"
    }
  }, [_c('span', [_vm._v("Meet the Team")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/what-sets-us-apart"
    }
  }, [_c('span', [_vm._v("What Sets Us Apart")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/contests"
    }
  }, [_c('span', [_vm._v("Contests")])])], 1)])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-visits"
    }
  }, [_c('span', [_vm._v("New Patients ")])]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-visits"
    }
  }, [_c('span', [_vm._v("Office Visits")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/financial-information"
    }
  }, [_c('span', [_vm._v("Financial Information")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/testimonials"
    }
  }, [_c('span', [_vm._v("Testimonials")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/before-and-after"
    }
  }, [_c('span', [_vm._v("Before and After ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/abo-certification"
    }
  }, [_c('span', [_vm._v("ABO Certification ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-tour"
    }
  }, [_c('span', [_vm._v("Office Tour ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/patient-forms"
    }
  }, [_c('span', [_vm._v("Patient Forms")])])], 1)])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_c('span', [_vm._v("Braces")])]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_c('span', [_vm._v("Life with Braces")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/types-of-braces"
    }
  }, [_c('span', [_vm._v("Types of Braces")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/types-of-appliances"
    }
  }, [_c('span', [_vm._v("Types of Appliances")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/retainer-instructions"
    }
  }, [_c('span', [_vm._v("Retainer Instructions ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/emergency-care"
    }
  }, [_c('span', [_vm._v("Emergency Care ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/orthodontic-retention"
    }
  }, [_c('span', [_vm._v("Orthodontic Retention")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/for-adults"
    }
  }, [_c('span', [_vm._v("For Adults ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/color-my-braces"
    }
  }, [_c('span', [_vm._v("Color My Braces")])])], 1)])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/common-orthodontic-issues"
    }
  }, [_c('span', [_vm._v("Ortho Treatments")])]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/common-orthodontic-issues"
    }
  }, [_c('span', [_vm._v("Common Orthodontic Issues")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/early-orthodontic-treatment"
    }
  }, [_c('span', [_vm._v("Early Orthodontic Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_c('span', [_vm._v("Surgical Orthodontics")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/itero-element"
    }
  }, [_c('span', [_vm._v("iTero® Element™ ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/tmj-tmd"
    }
  }, [_c('span', [_vm._v("TMJ-TMD ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/sleep-apnea"
    }
  }, [_c('span', [_vm._v("Sleep Apnea ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment-for-teens"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment for Teens ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/in-ovation"
    }
  }, [_c('span', [_vm._v("In-Ovation®")])])], 1)])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/rochester-office-location"
    }
  }, [_c('span', [_vm._v("Office Location")])]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/rochester-office-location"
    }
  }, [_c('span', [_vm._v("Rochester Office Location")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/appointment-request"
    }
  }, [_c('span', [_vm._v("Appointment Request")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/refer-a-friend"
    }
  }, [_c('span', [_vm._v("Refer a Friend                                    ")])])], 1)])], 1)]), _c('div', {
    staticClass: "mobile-nav-manual"
  }, [_c('div', {
    staticClass: "mobile_menu",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_vm._m(1), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-dr-deborah-new"
    }
  }, [_vm._v("About Us")]), _vm._m(2), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-1"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-dr-deborah-new"
    }
  }, [_c('span', [_vm._v("Meet Dr. Deborah New")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/meet-the-team"
    }
  }, [_c('span', [_vm._v("Meet the Team")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/what-sets-us-apart"
    }
  }, [_c('span', [_vm._v("What Sets Us Apart")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/contests"
    }
  }, [_c('span', [_vm._v("Contests")])])], 1)])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-visits"
    }
  }, [_vm._v("New Patients")]), _vm._m(3), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-2"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-visits"
    }
  }, [_c('span', [_vm._v("Office Visits")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/financial-information"
    }
  }, [_c('span', [_vm._v("Financial Information")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/testimonials"
    }
  }, [_c('span', [_vm._v("Testimonials")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/before-and-after"
    }
  }, [_c('span', [_vm._v("Before and After ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/abo-certification"
    }
  }, [_c('span', [_vm._v("ABO Certification ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/office-tour"
    }
  }, [_c('span', [_vm._v("Office Tour ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/patient-forms"
    }
  }, [_c('span', [_vm._v("Patient Forms        ")])])], 1)])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_vm._v("Braces")]), _vm._m(4), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-3"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_c('span', [_vm._v("Life with Braces")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/types-of-braces"
    }
  }, [_c('span', [_vm._v("Types of Braces")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/types-of-appliances"
    }
  }, [_c('span', [_vm._v("Types of Appliances")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/retainer-instructions"
    }
  }, [_c('span', [_vm._v("Retainer Instructions ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/emergency-care"
    }
  }, [_c('span', [_vm._v("Emergency Care ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/orthodontic-retention"
    }
  }, [_c('span', [_vm._v("Orthodontic Retention")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/for-adults"
    }
  }, [_c('span', [_vm._v("For Adults ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/color-my-braces"
    }
  }, [_c('span', [_vm._v("Color My Braces ")])])], 1)])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/common-orthodontic-issues"
    }
  }, [_vm._v("Ortho Treatments")]), _vm._m(5), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-3"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/common-orthodontic-issues"
    }
  }, [_c('span', [_vm._v("Common Orthodontic Issues")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/early-orthodontic-treatment"
    }
  }, [_c('span', [_vm._v("Early Orthodontic Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/surgical-orthodontics"
    }
  }, [_c('span', [_vm._v("Surgical Orthodontics")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/itero-element"
    }
  }, [_c('span', [_vm._v("iTero® Element™ ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/tmj-tmd"
    }
  }, [_c('span', [_vm._v("TMJ-TMD ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/sleep-apnea"
    }
  }, [_c('span', [_vm._v("Sleep Apnea ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/invisalign-treatment-for-teens"
    }
  }, [_c('span', [_vm._v("Invisalign® Treatment for Teens ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/in-ovation"
    }
  }, [_c('span', [_vm._v("In-Ovation®")])])], 1)])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/rochester-office-location"
    }
  }, [_vm._v("Office Location")]), _vm._m(6), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-4"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/rochester-office-location"
    }
  }, [_c('span', [_vm._v("Rochester Office Location")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/appointment-request"
    }
  }, [_c('span', [_vm._v("Appointment Request")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/refer-a-friend"
    }
  }, [_c('span', [_vm._v("Refer a Friend                       ")])])], 1)])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamb_icon",
    attrs: {
      "onclick": "openNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "closebtn idw-icon-close",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "closeNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(1)",
      "id": "toggleClass-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(2)",
      "id": "toggleClass-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(3)",
      "id": "toggleClass-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(3)",
      "id": "toggleClass-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(4)",
      "id": "toggleClass-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f91ed2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 591
// module chunks = 1